import React, { useState } from 'react';
import type { ReactElement } from 'react';
import {
  PillButton,
  Inline,
  Button,
  H2,
  Sheet,
  spacingHelper,
  ArrowDownMd,
} from '@construct-kit/core';
import styled from 'styled-components';

export type FilterPillButtonSheetProps = {
  filter: ReactElement;
  buttonLabel: string;
  sheetLabel: string;
  selected: boolean;
  onReset?: () => void;
  onFilterPillClose?: () => void;
  handleSearchOnClick: (onClose?: () => void) => void;
  onFilterPillOpen: () => void;
};

const FilterWrapper = styled.div`
  padding-bottom: ${spacingHelper('small')};
  width: 100%;
`;

const StyledPillButton = styled(PillButton)<{ isOpen: boolean }>`
  > svg {
    ${({ isOpen }) => (isOpen ? 'transform: rotate(-180deg)' : '')};
    transition: transform 0.2s;
  }
`;

export const FilterPillButtonSheet = ({
  filter,
  buttonLabel,
  sheetLabel,
  selected,
  onReset,
  onFilterPillClose,
  handleSearchOnClick,
  onFilterPillOpen,
}: FilterPillButtonSheetProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSheetClose = () => {
    setIsOpen(false);
    onFilterPillClose?.();
  };

  const handleButtonOpen = () => {
    setIsOpen(true);
    onFilterPillOpen();
  };

  return (
    <>
      <StyledPillButton
        onClick={handleButtonOpen}
        iconRight={<ArrowDownMd />}
        sizeVariant="small"
        selected={selected}
        isOpen={isOpen}
      >
        {buttonLabel}
      </StyledPillButton>
      <Sheet
        opened={isOpen}
        onRequestClose={handleSheetClose}
        getAppElement={() => document.getElementById('wrapper') ?? ''}
        headerAlignment="center"
        header={<H2>{sheetLabel}</H2>}
        footer={
          <Inline justifyContent="space-between" grow={false}>
            <Button variant="naked" onClick={onReset}>
              Reset
            </Button>
            <Button
              onClick={() => {
                handleSearchOnClick(() => {
                  setIsOpen(false);
                });
              }}
            >
              Search
            </Button>
          </Inline>
        }
        reactModalProps={{
          style: {
            content: {
              maxWidth: '100%',
            },
          },
        }}
      >
        <FilterWrapper>{filter}</FilterWrapper>
      </Sheet>
    </>
  );
};
